<template>
  <dp-payment-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-payment-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/DPCreateTemplate.vue'
  export default {
    name: 'Capsule-DirectPayment-Create',
    data: () => {
      return {
        title: 'New Direct Payment',
        capsule: 'direct-payment-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-payment-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TDirectPayments.vue?f8618b6a